/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';

const CustomContainer = ({ children, modifierClassName, inputRef, ...rest }) => (
	<div className={modifierClassName} {...rest} ref={inputRef}>
		{children}
	</div>
);

export default memo(CustomContainer);
